module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAYEAAAA/CAYAAAAG7nSVAAABDUlEQVR4nO3VQQ2EUBAFwfmEMyhlxaxTFEDQ0VUOJvOSXsc1zwCQtH9H338dAKg5f2s2XwfoEgGAMBEACBMBgDARAAgTAYAwEQAIEwGAMBEACBMBgDARAAgTAYAwEQAIEwGAMBEACBMBgDARAAgTAYAwEQAIEwGAMBEACBMBgDARAAgTAYAwEQAIEwGAMBEACBMBgDARAAgTAYAwEQAIEwGAMBEACBMBgDARAAgTAYAwEQAIEwGAMBEACBMBgDARAAgTAYAwEQAIEwGAMBEACBMBgDARAAgTAYAwEQAIEwGAMBEACBMBgDARAAgTAYAwEQAIEwGAMBEACBMBgDARAAgTAYCwdVzzGABA0My8iFAGc9avRr8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer2/inpuy-style.png
// module id = 2Cgi
// module chunks = 1